// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputChipsItem__container-a00208 {
  --input-chips-item-color: var(--base-110);
  --input-chips-item-height: 22px;
  background-color: var(--input-chips-item-background-color);
  color: var(--input-chips-item-color);
  border: 1px solid var(--input-chips-item-border-color);
  height: var(--input-chips-item-height);
  border-radius: var(--input-chips-item-height);
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  display: flex;
  align-items: center;
  gap: 6px;
}

.InputChipsItem__theme-standard-a48118 {
  --input-chips-item-background-color: transparent;
  --input-chips-item-background-color-hover: var(--base-15);
  --input-chips-item-background-color-active: var(--base-15);
  --input-chips-item-border-color: var(--base-30);
  --input-chips-item-border-color-hover: var(--base-20);
  --input-chips-item-border-color-active: var(--base-40);
}

.InputChipsItem__theme-warning-d24997 {
  --input-chips-item-background-color: var(--base-0);
  --input-chips-item-background-color-hover: var(--base-15);
  --input-chips-item-background-color-hover: var(--base-20);
  --input-chips-item-border-color: var(--warning-40);
  --input-chips-item-border-color-hover: var(--warning-40);
  --input-chips-item-border-color-active: var(--warning-40);
}

.InputChipsItem__theme-danger-b2a526 {
  --input-chips-item-background-color: var(--base-0);
  --input-chips-item-background-color-hover: var(--base-15);
  --input-chips-item-background-color-hover: var(--base-20);
  --input-chips-item-border-color: var(--danger-40);
  --input-chips-item-border-color-hover: var(--danger-40);
  --input-chips-item-border-color-active: var(--danger-40);
}

.InputChipsItem__theme-light-a85edd {
  --input-chips-item-background-color: var(--base-0);
  --input-chips-item-background-color-hover: var(--base-0);
  --input-chips-item-background-color-active: var(--base-0);
  --input-chips-item-border-color: var(--base-17);
  --input-chips-item-border-color-hover: var(--base-30);
  --input-chips-item-border-color-active: var(--base-40);
}

.InputChipsItem__with-remove-button-f5b34e {
  padding-inline-end: 6px;
}

.InputChipsItem__container-a00208:hover,
.InputChipsItem__container-a00208:focus {
  background-color: var(--input-chips-item-background-color-hover);
}

.InputChipsItem__container-a00208:active {
  background-color: var(--input-chips-item-background-color-active);
  border-color: var(--input-chips-item-border-color-active);
}

.InputChipsItem__container-a00208.InputChipsItem__disabled-f91a31,
.InputChipsItem__container-a00208.InputChipsItem__disabled-f91a31:active,
.InputChipsItem__container-a00208.InputChipsItem__disabled-f91a31:focus,
.InputChipsItem__container-a00208.InputChipsItem__disabled-f91a31:hover {
  background-color: var(--input-chips-item-background-color);
  border-color: var(--input-chips-item-border-color);
  color: var(--input-chips-item-color);
  opacity: 0.5;
}

.InputChipsItem__content-fcbbfc {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.InputChipsItem__icon-ae9853 {
  fill: var(--base-90);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/InputChips/InputChipsItem/InputChipsItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yCAAA;EACA,+BAAA;EAEA,0DAAA;EACA,oCAAA;EACA,sDAAA;EACA,sCAAA;EACA,6CAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,wBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,gDAAA;EACA,yDAAA;EACA,0DAAA;EAEA,+CAAA;EACA,qDAAA;EACA,sDAAA;AADF;;AAIA;EACE,kDAAA;EACA,yDAAA;EACA,yDAAA;EAEA,kDAAA;EACA,wDAAA;EACA,yDAAA;AAFF;;AAKA;EACE,kDAAA;EACA,yDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,uDAAA;EACA,wDAAA;AAHF;;AAMA;EACE,kDAAA;EACA,wDAAA;EACA,yDAAA;EAEA,+CAAA;EACA,qDAAA;EACA,sDAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA;;EAEE,gEAAA;AAJF;;AAOA;EACE,iEAAA;EACA,yDAAA;AAJF;;AAOA;;;;EAIE,0DAAA;EACA,kDAAA;EACA,oCAAA;EACA,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,oBAAA;AAJF","sourcesContent":[".container {\n  --input-chips-item-color: var(--base-110);\n  --input-chips-item-height: 22px;\n\n  background-color: var(--input-chips-item-background-color);\n  color: var(--input-chips-item-color);\n  border: 1px solid var(--input-chips-item-border-color);\n  height: var(--input-chips-item-height);\n  border-radius: var(--input-chips-item-height);\n  padding: 4px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.theme-standard {\n  --input-chips-item-background-color: transparent;\n  --input-chips-item-background-color-hover: var(--base-15);\n  --input-chips-item-background-color-active: var(--base-15);\n\n  --input-chips-item-border-color: var(--base-30);\n  --input-chips-item-border-color-hover: var(--base-20);\n  --input-chips-item-border-color-active: var(--base-40);\n}\n\n.theme-warning {\n  --input-chips-item-background-color: var(--base-0);\n  --input-chips-item-background-color-hover: var(--base-15);\n  --input-chips-item-background-color-hover: var(--base-20);\n\n  --input-chips-item-border-color: var(--warning-40);\n  --input-chips-item-border-color-hover: var(--warning-40);\n  --input-chips-item-border-color-active: var(--warning-40);\n}\n\n.theme-danger {\n  --input-chips-item-background-color: var(--base-0);\n  --input-chips-item-background-color-hover: var(--base-15);\n  --input-chips-item-background-color-hover: var(--base-20);\n\n  --input-chips-item-border-color: var(--danger-40);\n  --input-chips-item-border-color-hover: var(--danger-40);\n  --input-chips-item-border-color-active: var(--danger-40);\n}\n\n.theme-light {\n  --input-chips-item-background-color: var(--base-0);\n  --input-chips-item-background-color-hover: var(--base-0);\n  --input-chips-item-background-color-active: var(--base-0);\n\n  --input-chips-item-border-color: var(--base-17);\n  --input-chips-item-border-color-hover: var(--base-30);\n  --input-chips-item-border-color-active: var(--base-40);\n}\n\n.with-remove-button {\n  padding-inline-end: 6px;\n}\n\n.container:hover,\n.container:focus {\n  background-color: var(--input-chips-item-background-color-hover);\n}\n\n.container:active {\n  background-color: var(--input-chips-item-background-color-active);\n  border-color: var(--input-chips-item-border-color-active);\n}\n\n.container.disabled,\n.container.disabled:active,\n.container.disabled:focus,\n.container.disabled:hover {\n  background-color: var(--input-chips-item-background-color);\n  border-color: var(--input-chips-item-border-color);\n  color: var(--input-chips-item-color);\n  opacity: 0.5;\n}\n\n.content {\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.icon {\n  fill: var(--base-90);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InputChipsItem__container-a00208`,
	"theme-standard": `InputChipsItem__theme-standard-a48118`,
	"themeStandard": `InputChipsItem__theme-standard-a48118`,
	"theme-warning": `InputChipsItem__theme-warning-d24997`,
	"themeWarning": `InputChipsItem__theme-warning-d24997`,
	"theme-danger": `InputChipsItem__theme-danger-b2a526`,
	"themeDanger": `InputChipsItem__theme-danger-b2a526`,
	"theme-light": `InputChipsItem__theme-light-a85edd`,
	"themeLight": `InputChipsItem__theme-light-a85edd`,
	"with-remove-button": `InputChipsItem__with-remove-button-f5b34e`,
	"withRemoveButton": `InputChipsItem__with-remove-button-f5b34e`,
	"disabled": `InputChipsItem__disabled-f91a31`,
	"content": `InputChipsItem__content-fcbbfc`,
	"icon": `InputChipsItem__icon-ae9853`
};
module.exports = ___CSS_LOADER_EXPORT___;
